import { render } from "./PreMatchReport.vue?vue&type=template&id=f338dc60&scoped=true"
import script from "./PreMatchReport.vue?vue&type=script&lang=js"
export * from "./PreMatchReport.vue?vue&type=script&lang=js"

import "./PreMatchReport.vue?vue&type=style&index=0&id=f338dc60&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f338dc60"]])

export default __exports__